import { useViewjobProctorAllocation } from "../../../../../proctor/__generated__/ViewjobProctorContext";
import { MobVjCompanyConquestingTst } from "../../../../../proctor/__generated__/ViewjobProctorSpecifications";
import { useViewjobOneGraphModel } from "../../../../context/ViewJobDataContext";

const ENABLED_BUCKETS = new Set([3, 4, 5]);

/**
 * Keeps the heavy recommendations and JobCard graph out of the initial bundle
 * unless this job and Proctor allocation can render it.
 */
export function useShouldLoadCompanyConquesting(): boolean {
  const viewjobOneGraphModel = useViewjobOneGraphModel();
  const allocation = useViewjobProctorAllocation(MobVjCompanyConquestingTst);

  return (
    ENABLED_BUCKETS.has(allocation.value) &&
    viewjobOneGraphModel?.job?.shouldClientSideLoadCompetitorsJobs === true
  );
}
